import { logger } from "@otto-ec/global-resources/debug";
import { captureError } from "@otto-ec/global-resources/apm";

const log = logger("hopper:auction-cinema");

function logError(error: Error) {
  log.error(error);
  return captureError(
    error,
    { service: "auction-cinema", team: "hopper" },
    { type: "auction-cinema-error" },
  );
}

export { logError };
